import { isFloat, parseFloatWithComma } from 'utils';
export function prefix_error2(prefix, validator) {
    return (value) => {
        const result = validator(value);
        if (typeof result === 'string')
            return `${prefix} ${result}`;
        return result;
    };
}
export function undefinedOr(validator) {
    // export function undefinedOr(validator: Validator) {
    return (value, misc) => {
        if (value === undefined)
            return null;
        return validator(value, misc);
    };
}
export function notEmpty(value) {
    if (value == null || value.length === 0)
        return 'Значение не может быть пустым';
    else
        return null;
}
export function notEmptyAnd(validator) {
    return (value, extra) => {
        if (value == null || value.length === 0)
            return 'Значение не может быть пустым';
        return validator(value, extra);
    };
}
export function notEmptyWithMsg(msg) {
    return (value) => {
        if (value == null || value.length === 0)
            return msg;
        return null;
    };
}
export function notEmptyTrimmedWithMsg(msg) {
    return (value) => {
        if (value == null || value.trim().length === 0)
            return msg;
        return null;
    };
}
export function maxStringLength(max, msg) {
    return (value) => {
        if (typeof value !== 'string')
            return null;
        if (value.length > max)
            return msg;
        return null;
    };
}
export function minStringLength(min, msg) {
    return (value) => {
        if (typeof value !== 'string')
            return null;
        if (value.length < min)
            return msg;
        return null;
    };
}
export function minMaxStr(min, max) {
    return (value) => {
        if (value == null)
            return 'необходимо ввести значение';
        if (value.length === 0 && min > 0)
            return 'необходимо ввести значение';
        if (value.length < min)
            return `должно быть не менее ${min} знаков`;
        if (value.length > max)
            return `должно быть не более ${max} знаков`;
        return null;
    };
}
export function matchesRegex(regex, msg) {
    return (value) => {
        if (value == null || !value.match(regex))
            return msg;
        return null;
    };
}
export function isNumber(value) {
    if (!isFloat('' + value))
        return 'Значение не является числом';
    return null;
}
export function isInteger(value) {
    const isNum = isNumber(value);
    return isNum
        ? isNum
        : Math.round(~~value) === +value
            ? null
            : 'Значение не является целым числом';
}
export function isIntegerNumber(value) {
    if (value % 1 != 0) {
        return 'Значение не является целым числом';
    }
    return null;
}
export function minMax(min, max, error_message) {
    return (value) => {
        const v = parseFloatWithComma(value);
        if (v == null) {
            return 'Значение не является числом';
        }
        // const isnum = isNumber(v);
        // if (isnum != null) {
        //     return isnum;
        // }
        if (v < min || v > max) {
            if (error_message)
                return error_message;
            return `Допустимые значения: от ${min} до ${max}`;
        }
        return null;
    };
}
export function EqualsThreshold(minValue, maxValue, error_message) {
    if (minValue != null && maxValue != null) {
        if (minValue === maxValue) {
            if (error_message) {
                return error_message;
            }
            return `Нижний порог не должен быть равен верхнему`;
        }
        if (minValue > maxValue) {
            if (error_message) {
                return error_message;
            }
            return `Нижний порог не должен быть больше верхнего`;
        }
    }
    return null;
}
export function orNull(validator) {
    return (value, aux_data) => {
        if (value == null) {
            return null;
        }
        return validator(value, aux_data);
    };
}
export function notNull(value) {
    if (value == null)
        return 'Введите значение';
    return null;
}
export function validatePassword(value, value_2) {
    if (value === '' && value_2 === '')
        return null;
    if (value == null || value_2 == null)
        return 'Введите подтверждение пароля';
    if (value !== value_2)
        return 'Пароли не совпадают';
    if (value.length < 5 && value_2 !== 'ilya')
        return 'Пароль должен быть не короче 5 символов';
    return null;
}
export function notNullAnd(validator) {
    return (value, extra) => {
        if (value == null)
            return 'Введите значение';
        return validator(value, extra);
    };
}
export function conditional(predicate, validator) {
    return (obj, misc) => {
        if (predicate(obj))
            return validator(obj, misc);
        return null;
    };
}
